import { httpClient } from "./http";
import config from "../config";

export const getCheckoutURL = async (course_id: string) => {
  const resp = await httpClient.post(
    config.API_URL + `/gateway/checkout/${course_id}`
  );
  return resp.data;
};
